import { render, staticRenderFns } from "./CardSnippet.vue?vue&type=template&id=40d3509a&"
import script from "./CardSnippet.vue?vue&type=script&lang=js&"
export * from "./CardSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports